import React, { useState,useEffect } from "react";
import { useMutation, useApolloClient } from "@apollo/client";
import { LOGIN_WITH_TOKEN_MUTATION } from '../../graphqlDefs/magicOuth/mutations';  

export const useLoginWithToken = () => {
  const client = useApolloClient();
  const [loginWithTokenMutation, { data, error }] = useMutation(LOGIN_WITH_TOKEN_MUTATION);
  const loginWithToken = async (token) => {
    const { data, errors } = await loginWithTokenMutation({ variables: { token } });
    return {
      defaultPage: data?.loginWithToken?.defaultPage,
      token: data?.loginWithToken?.token,
    };
  };
  return {
    loginWithToken, 
  };
};

export default useLoginWithToken;
